module.exports = __webpack_public_path__ + "static/media/c9bannerModulE_small.c83ddc4b.jpg";